var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4657 17.9953C12.1742 17.8417 11.8257 17.8416 11.5341 17.9949L7.62157 20.052C6.88793 20.4377 6.03047 19.8147 6.1706 18.9978L6.91804 14.6406C6.97373 14.3159 6.86598 13.9847 6.62995 13.7549L3.4609 10.6702C2.86662 10.0917 3.19423 9.08289 4.01498 8.96394L8.38647 8.33039C8.71233 8.28317 8.99406 8.07856 9.13978 7.78329L11.0963 3.81897C11.4631 3.07571 12.5229 3.07571 12.8897 3.81897L14.8462 7.78329C14.9919 8.07856 15.2737 8.28317 15.5995 8.33039L19.971 8.96394C20.7918 9.08289 21.1194 10.0917 20.5251 10.6702L17.3561 13.7549C17.12 13.9847 17.0123 14.3159 17.068 14.6406L17.815 18.9954C17.9552 19.8128 17.0969 20.4358 16.3632 20.0492L12.4657 17.9953Z",
    fill: "#FFD912"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e8cc8777201bb413f87e9d881badd22b.svg";
export { ForwardRef as ReactComponent };